<template>
  <div class="live2d">
    <div id="__spine_player_container__"></div>
    <div class="mask">
      <div class="empty" v-if="isEmpty && !loading">
        <img src="@/assets/zs_imgs/empty-img.png" alt="" />
        <div>资料暂时空缺，留言让版主加急</div>
      </div>
      <div class="loading" v-if="loading">
        <div class="loader">
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
        </div>
        <div class="text">正在加载中哦</div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript, loadCSS } from "@/plugins/util";
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    animation: {
      type: String,
      default: "idle"
    }
  },
  data() {
    return {
      lhVisible: false,
      live2dVisible: false,
      loading: false,
      isEmpty: false
    };
  },
  watch: {
    dataSource: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.loading = true;
          this.initSpine("__spine_player_container__");
        });
      },
      deep: true
    }
  },
  mounted() {
    this.loading = true;
    this.initSpine("__spine_player_container__");
  },
  methods: {
    initSpine(container) {
      const data = this.dataSource.source.value;
      console.log(data);

      if (typeof data === "object") {
        if (!data.skel) {
          this.loading = false;
          return;
        }
        this.isEmpty = false;
        const _this = this;

        const options = {
          // Relative URLs
          skelUrl: this.foramtUrl(data.skel),
          atlasUrl: this.foramtUrl(data.atlas),
          animation: this.animation,
          showLoading: false,
          showControls: false,
          alpha: true,
          backgroundColor: "#00000000",
          success: function(player) {
            _this.loading = false;
            _this.isEmpty = false;
          }
        };
        fetch(data.skel)
          .then(response => response.blob())
          .then(blob => blob.slice(0, 16).text())
          .then(str => {
            console.log();
            if (/4\.0\.\d+/.test(str)) {
              // 加载css
              loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.css?t=10001`);
              loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.js?t=10001`).then(res => {
                // 先获取到spine可执行的动画
                document.querySelector("#" + container).innerHTML = null;
                // eslint-disable-next-line
                new window.spine_4_0_30.SpinePlayer(container, options);
              });
            } else if (/4\.1\.\d+/.test(str)) {
              // 加载css
              loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.css?t=10001`);
              loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.js?t=10001`).then(res => {
                // 先获取到spine可执行的动画
                document.querySelector("#" + container).innerHTML = null;
                // eslint-disable-next-line
                new window.spine_4_1_54.SpinePlayer(container, options);
              });
            }
          })
          .catch(() => {
            this.isEmpty = true;
          });
        // const animations = Object.keys(json.animations);
        // if (n.live2d.current_id === "mbg004_appearance")
        //             return "mbg004_appearance";
        //         if (n.live2d.current_id === "smol_rem" || n.live2d.current_id === "smol_ram" || n.live2d.current_id === "smol_emilia" || n.live2d.current_id === "smol_mast_pirate" || n.live2d.current_id === "smol_anchor_pirate" || n.live2d.current_id === "smol_sin_pirate")
        //             return "idle_front";
        //         if (n.live2d.current_id === "c994")
        //             return "idle_02";
        //         if (n.live2d.current_id.includes("favorite"))
        //             return "idle_merged";
        //         switch (n.live2d.current_pose) {
        //         case "aim":
        //             return "aim_idle";
        //         case "cover":
        //             return "cover_idle";
        //         default:
        //             return "idle"
        //         }
      } else if (data) {
        this.loading = false;
        this.isEmpty = false;
        document.querySelector("#" + container).innerHTML = `<img class="lh-img" src="${data}" alt="" />`;
      } else {
        this.loading = false;
        this.isEmpty = true;
      }
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  margin-top: -100px;
  img {
    width: 190px;
    height: 163px;
    margin-bottom: 7px;
  }
}
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #333;
  line-height: 14px;
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;
    .item {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #3eafff;
      animation: ball-beat 0.7s -0.15s infinite linear;
      &:nth-child(2n-1) {
        animation-delay: -0.5s;
      }
    }

    @keyframes ball-beat {
      50% {
        opacity: 0.2;
        transform: scale(0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.live2d {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;

  /deep/ #__spine_player_container__ {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 380px;
      max-height: 100%;
    }
  }

  // .bg {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 638px;
  //   background: url("~@/assets/zs_imgs/live2d-box-bg.png");
  //   background-size: 100% 100%;
  // }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #ffffff00;
    color: #ffffff00;
    display: flex;
    align-items: center;
    justify-content: center;
    .btns {
      position: absolute;
      right: 0;
      top: 21px;
      width: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 14px;
    }
    .btn {
      display: inline-block;
      width: 27px;
      height: 27px;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
